import { $ } from "../dom";

export type WebflowCMSPaginatedList = {
  isPaginated: true;

  currentPage: number | null;
  pageCount: number | null;

  nextPageElement: Element | null;
  previousPageElement: Element | null;

  nextPageHref: string | null;
  previousPageHref: string | null;
};

export type WebflowCMSList =
  | WebflowCMSPaginatedList
  | {
      isPaginated: false;
    };

export const WEBFLOW_CMS_LIST_WRAPPER_CLASS = "w-dyn-list";
export const WEBFLOW_CMS_LIST_CLASS = "w-dyn-items";
export const WEBFLOW_CMS_LIST_ITEM_CLASS = "w-dyn-item";
export const WEBFLOW_CMS_LIST_PAGINATION_WRAPPER_CLASS = "w-pagination-wrapper";
export const WEBFLOW_CMS_LIST_PAGINATION_NEXT_CLASS = "w-pagination-next";
export const WEBFLOW_CMS_LIST_PAGINATION_PREVIOUS_CLASS =
  "w-pagination-previous";
export const WEBFLOW_CMS_LIST_PAGINATION_PAGE_COUNT_CLASS = "w-page-count";

export const getWebflowCMSListWrapperSelectorById = (id: string) =>
  `.${WEBFLOW_CMS_LIST_WRAPPER_CLASS}:has([href^="?${id}"])`;

export const getWebflowCMSListPageParamKey = (id: string) => {
  return `${id}_page`;
};

export const getWebflowCMSListPageParamValue = (page: number) => {
  return String(page + 1);
};

export const getWebflowCMSListPageHrefById = (id: string, index: number) =>
  `${window.location.origin}${window.location.pathname}?${getWebflowCMSListPageParamKey(id)}=${getWebflowCMSListPageParamValue(index)}`;

export function isWebflowCMSList(list: Element): WebflowCMSList | null {
  const $list = $.make(list);

  if (!$.make(list).is(`.${WEBFLOW_CMS_LIST_CLASS}`)) {
    return null;
  }

  const nextPageElement =
    $list.parent.find(`.${WEBFLOW_CMS_LIST_PAGINATION_NEXT_CLASS}`).first;
  const previousPageElement = $list.parent.find(
    `.${WEBFLOW_CMS_LIST_PAGINATION_PREVIOUS_CLASS}`,
  ).first;

  const nextPageHref = nextPageElement?.getAttribute("href") ?? null;
  const previousPageHref = previousPageElement?.getAttribute("href") ?? null;

  const pageCountLabel =
    $list.parent
      .find(`.${WEBFLOW_CMS_LIST_PAGINATION_PAGE_COUNT_CLASS}`)
      .attr("aria-label") || null;

  const pageHref = nextPageHref ?? previousPageHref;

  const isPaginated = !!pageHref;

  if (!isPaginated) {
    return {
      isPaginated,
    };
  }

  let currentPage: number | null = null;
  let pageCount: number | null = null;

  if (pageCountLabel) {
    const match = pageCountLabel.match(/page\s+(\d+)\s+of\s+(\d+)/i);

    if (match) {
      currentPage = Number(match[1]) - 1;
      pageCount = Number(match[2]);
    }
  }

  return {
    isPaginated,

    nextPageElement,
    previousPageElement,

    nextPageHref,
    previousPageHref,

    currentPage,
    pageCount,
  };
}

export function isWebflowCMSPaginatedList(
  list: Element,
): WebflowCMSPaginatedList | null {
  const webflowCMSList = isWebflowCMSList(list);

  if (!webflowCMSList?.isPaginated) {
    return null;
  }

  return webflowCMSList;
}
